
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31068",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31068",
  "emoji-mart": "static-3.9",
  "feedback-schema": "static-1.55657",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8548",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11997",
  "I18n": "static-7.1717",
  "quartz": "static-1.7699",
  "quartz-config": "static-1.1477",
  "quartz-core": "static-1.6918",
  "react-dlb": "static-1.96",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.86",
  "reselect": "static-3.18",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1131",
  "enviro": "static-4.523",
  "feedback-shared-ui": "static-1.55644",
  "feedback-utils": "static-1.55648",
  "forms-embed-utils-lib": "static-1.4969",
  "forms-utils-lib": "static-1.13386",
  "foundations-assets": "static-1.5396",
  "foundations-components": "static-1.8800",
  "foundations-theming": "static-1.5000",
  "hub-http": "static-1.6711",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12304",
  "icons": "static-2.710",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4248",
  "raven": "static-3.6411",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17244",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5683",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.520",
  "tinymce-plugins": "static-1.58568",
  "transmute": "static-2.97",
  "ui-images": "static-2.1285",
  "UIComponents": "static-3.8943",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3976",
  "quartz-webpack": "static-1.3923",
  "foundations-theming-specialty": "static-1.2716",
  "property-description-translator": "static-1.4326",
  "HeadJS": "static-2.830",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3659",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4811",
  "jasmine-runner": "static-1.6962",
  "opentelemetry-fe-types": "static-1.301",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.914",
  "hubspotter-http": "static-1.4992",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.676",
  "quartz-auth": "static-1.1374",
  "quartz-head": "static-1.1364",
  "quartz-i18n": "static-1.1374",
  "quartz-routing": "static-1.1129",
  "quartz-test": "static-1.1374",
  "quartz-tracking": "static-1.1078",
  "trellis-components": "static-1.3197",
  "ui-fonts": "static-1.1259",
  "usage-tracker-container": "static-1.7817",
  "usage-tracker-core": "static-1.7677",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.392",
  "conversations-skeleton-state": "static-1.7623",
  "reference-resolvers": "static-1.8693",
  "sanitize-text": "static-1.8667",
  "PatternValidationJS": "static-1.3389",
  "ReduxMessenger": "static-2.10879",
  "outpost": "static-1.4639",
  "rpc-client-utils": "static-1.5171",
  "sanitize": "static-1.4975",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5069",
  "floating-ui": "static-1.70",
  "hs-story-utils": "static-1.9937",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.113",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3178",
  "bend-plugin-foundations-theming": "static-1.3483",
  "foundations-theming-base": "static-1.3985",
  "stylex": "static-1.48",
  "hs-locale-management": "static-1.420",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.208",
  "web-vitals": "static-1.21",
  "ai-components-ui-library": "static-1.10077",
  "atom": "static-1.5581",
  "codemirror": "static-5.108",
  "content-assistance-lib": "static-1.8468",
  "ContentUtils": "static-1.69551",
  "data-token-picker": "static-1.17185",
  "file-manager-components": "static-1.24891",
  "FileManagerCore": "static-1.40390",
  "FileManagerLib": "static-1.40531",
  "frontend-preferences-client": "static-1.8428",
  "hub-http-contrib": "static-1.3537",
  "interframe": "static-3.5248",
  "layout-dnd-components": "static-1.13274",
  "layout-dnd-utils": "static-1.12249",
  "property-translator": "static-1.5886",
  "react-codemirror": "static-1.11149",
  "react-colorpicker": "static-2.10714",
  "reference-resolvers-lite": "static-1.8620",
  "rich-text-lib": "static-1.20605",
  "tinymce-data": "static-1.41539",
  "tinymce-themes": "static-1.57424",
  "ui-addon-emoji-picker": "static-1.10372",
  "ui-addon-sales-email": "static-1.5712",
  "ui-brand-identity-lib": "static-1.17022",
  "bender-build-tools": "static-1.3622",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10957",
  "hubspotter-http-shared-msw-handlers": "static-1.10955",
  "usage-tracker-session-replay": "static-1.5513",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "trellis-theming": "static-1.1529",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.581",
  "chirp-fetch": "static-1.2410",
  "stylex-utils": "static-1.184",
  "chatspot-core": "static-1.24081",
  "copilot-toolkit": "static-1.12212",
  "customer-data-objects-ui-components": "static-1.13541",
  "data-fetching-client": "static-1.10146",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5263",
  "ui-addon-video-player": "static-1.9128",
  "ui-coaching-tips": "static-1.29614",
  "usage-tracker": "static-1.7827",
  "cms-field-types": "static-1.5320",
  "content-icons-ui": "static-1.2490",
  "integrations-lib": "static-1.17498",
  "customer-data-objects": "static-1.8220",
  "apollo-dlb": "static-3.98",
  "apollo-link-hub-http": "static-2.5098",
  "apollo-stack-hubspot": "static-3.101",
  "breeze-engine-lib": "static-1.2284",
  "graphql": "static-1.95",
  "immer": "static-1.107",
  "immerable": "static-1.4648",
  "poll-commands": "static-1.3982",
  "ui-addon-iframeable": "static-1.9586",
  "video-components-external": "static-1.12501",
  "video-data-lib": "static-1.36159",
  "audio-components": "static-1.6614",
  "breeze-artifacts-sdk": "static-1.1094",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30107",
  "FileManagerImages": "static-1.38042",
  "foundations-components-legacy": "static-1.1825",
  "html-to-image": "static-1.67",
  "redux-toolkit": "static-1.84",
  "salesImages": "static-1.765",
  "ui-universal-auth": "static-1.9806",
  "urlinator": "static-1.5023",
  "video-components": "static-1.14503",
  "video-embed": "static-1.36993",
  "ts-schema": "static-1.4412",
  "ContentData": "static-1.69626",
  "layout-data-lib": "static-1.10574",
  "react-dnd-compat": "static-1.5113",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2059",
  "external-options-client-types": "static-1.4456",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6097",
  "hs-resources": "static-1.695",
  "inbound-db-properties-service-client": "static-1.4169",
  "NamespacedHubStyle": "static-2.9385",
  "growth-onboarding-confetti": "static-1.3567",
  "SharedI18nStrings": "static-1.190",
  "ui-addon-i18n": "static-1.11654",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5934",
  "magpie-types": "static-1.5394",
  "simple-logging-lib": "static-1.3556",
  "avatar-components": "static-1.2996",
  "customer-data-ui-utilities": "static-1.10341",
  "growth-onboarding-feedback-components": "static-1.7090",
  "flux-actions": "static-1.383",
  "hubspot-apollo-client": "static-1.5388",
  "integrations-error-boundary-lib": "static-1.14913",
  "integrations-tracking-lib": "static-1.6133",
  "laboratory-lib": "static-3.7656",
  "native-integrations-shared-strings": "static-1.8267",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10791",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1262",
  "breeze-engine-core": "static-1.1562",
  "highlight.js": "static-1.92",
  "pulse": "static-1.1162",
  "navigation-messaging": "static-1.8559",
  "content-media-composition-data-lib": "static-1.13649",
  "content-media-compositions": "static-2.17656",
  "idb-keyval": "static-1.57",
  "media-bridge-lib": "static-1.19689",
  "nudge-client-utils": "static-1.3470",
  "custom-vendor-connection-lib": "static-1.370",
  "unified-auth-core-lib": "static-1.1602",
  "social-insights-client-types": "static-1.22984",
  "advanced-menus-core": "static-1.15867",
  "advanced-menus-lib": "static-1.12607",
  "ExportDialog": "static-6.10881",
  "ui-memberships-settings-lib": "static-1.35267",
  "conditional-properties-service-client": "static-1.4131",
  "crm-pipelines-api-client-types": "static-1.4461",
  "event-emitter": "static-1.1466",
  "fdsr-migration-layer": "static-1.522",
  "framework-builder-read-service-client": "static-1.4353",
  "inbound-db-meta-service-client": "static-1.3792",
  "multi-currency-client-types": "static-1.4026",
  "foundations-components-test-utils": "static-1.6283",
  "reactive-lib": "static-1.1229",
  "trellis-migration-context": "static-1.87",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.847",
  "universal-page-editor-lib": "static-1.3523",
  "bend-plugin-pulse": "static-1.665",
  "fast-json-patch": "static-1.76",
  "nav-meta": "static-1.30869",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3227",
  "nudge-renderer-utils": "static-1.3546",
  "onboarding-tours": "static-1.17438",
  "whisper-core-api": "static-1.7685",
  "fsm": "static-1.4267",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15866",
  "simple-menus-lib": "static-1.17383",
  "settings-ui-lib": "static-1.13037",
  "persist-promise": "static-1.4216",
  "crm-record-cards-client": "static-1.139",
  "crm-record-cards-service-types": "static-1.3879",
  "framework-data-schema-resolvers": "static-1.7403",
  "location-customization-utils-lib": "static-1.10486",
  "getting-started-shared-tasks": "static-1.19621",
  "growth-data-modal": "static-1.6177",
  "growth-onboarding-next-action-utils": "static-1.3042",
  "navigation-components": "static-1.19232",
  "nest": "static-1.743",
  "onboarding-tours-client": "static-1.5653",
  "onboarding-tours-utils": "static-1.1505",
  "ui-shepherd-tracker": "static-1.8172",
  "user-context": "static-1.5564",
  "react-flip-move": "static-1.85",
  "framework-data-schema-quick-fetch": "static-1.7308",
  "onboarding-data-sync-lib": "static-1.2884",
  "growth-onboarding-next-action-components": "static-1.3070",
  "user-context-client": "static-1.5018",
  "getting-started-shared-tasks-store": "static-1.18739",
  "InboxConnectUtils": "static-4.15899",
  "meetings-connect-utils-lib": "static-1.8125",
  "onboarding-scopes": "static-1.6958"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31068",
  "emoji-mart": "/emoji-mart/static-3.9",
  "feedback-schema": "/feedback-schema/static-1.55657",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8548",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11997",
  "I18n": "/I18n/static-7.1717",
  "quartz": "/quartz/static-1.7699",
  "quartz-config": "/quartz-config/static-1.1477",
  "quartz-core": "/quartz-core/static-1.6918",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.86",
  "reselect": "/reselect/static-3.18",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1131",
  "enviro": "/enviro/static-4.523",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55644",
  "feedback-utils": "/feedback-utils/static-1.55648",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4969",
  "forms-utils-lib": "/forms-utils-lib/static-1.13386",
  "foundations-assets": "/foundations-assets/static-1.5396",
  "foundations-components": "/foundations-components/static-1.8800",
  "foundations-theming": "/foundations-theming/static-1.5000",
  "hub-http": "/hub-http/static-1.6711",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12304",
  "icons": "/icons/static-2.710",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4248",
  "raven": "/raven/static-3.6411",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17244",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5683",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tinymce-plugins": "/tinymce-plugins/static-1.58568",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1285",
  "UIComponents": "/UIComponents/static-3.8943",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3976",
  "quartz-webpack": "/quartz-webpack/static-1.3923",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2716",
  "property-description-translator": "/property-description-translator/static-1.4326",
  "HeadJS": "/HeadJS/static-2.830",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3659",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4811",
  "jasmine-runner": "/jasmine-runner/static-1.6962",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.301",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hubspotter-http": "/hubspotter-http/static-1.4992",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.676",
  "quartz-auth": "/quartz-auth/static-1.1374",
  "quartz-head": "/quartz-head/static-1.1364",
  "quartz-i18n": "/quartz-i18n/static-1.1374",
  "quartz-routing": "/quartz-routing/static-1.1129",
  "quartz-test": "/quartz-test/static-1.1374",
  "quartz-tracking": "/quartz-tracking/static-1.1078",
  "trellis-components": "/trellis-components/static-1.3197",
  "ui-fonts": "/ui-fonts/static-1.1259",
  "usage-tracker-container": "/usage-tracker-container/static-1.7817",
  "usage-tracker-core": "/usage-tracker-core/static-1.7677",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.392",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7623",
  "reference-resolvers": "/reference-resolvers/static-1.8693",
  "sanitize-text": "/sanitize-text/static-1.8667",
  "PatternValidationJS": "/PatternValidationJS/static-1.3389",
  "ReduxMessenger": "/ReduxMessenger/static-2.10879",
  "outpost": "/outpost/static-1.4639",
  "rpc-client-utils": "/rpc-client-utils/static-1.5171",
  "sanitize": "/sanitize/static-1.4975",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5069",
  "floating-ui": "/floating-ui/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9937",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.113",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3178",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3483",
  "foundations-theming-base": "/foundations-theming-base/static-1.3985",
  "stylex": "/stylex/static-1.48",
  "hs-locale-management": "/hs-locale-management/static-1.420",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.208",
  "web-vitals": "/web-vitals/static-1.21",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10077",
  "atom": "/atom/static-1.5581",
  "codemirror": "/codemirror/static-5.108",
  "content-assistance-lib": "/content-assistance-lib/static-1.8468",
  "ContentUtils": "/ContentUtils/static-1.69551",
  "data-token-picker": "/data-token-picker/static-1.17185",
  "file-manager-components": "/file-manager-components/static-1.24891",
  "FileManagerCore": "/FileManagerCore/static-1.40390",
  "FileManagerLib": "/FileManagerLib/static-1.40531",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8428",
  "hub-http-contrib": "/hub-http-contrib/static-1.3537",
  "interframe": "/interframe/static-3.5248",
  "layout-dnd-components": "/layout-dnd-components/static-1.13274",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12249",
  "property-translator": "/property-translator/static-1.5886",
  "react-codemirror": "/react-codemirror/static-1.11149",
  "react-colorpicker": "/react-colorpicker/static-2.10714",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8620",
  "rich-text-lib": "/rich-text-lib/static-1.20605",
  "tinymce-data": "/tinymce-data/static-1.41539",
  "tinymce-themes": "/tinymce-themes/static-1.57424",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10372",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5712",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17022",
  "bender-build-tools": "/bender-build-tools/static-1.3622",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10957",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10955",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5513",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "trellis-theming": "/trellis-theming/static-1.1529",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.581",
  "chirp-fetch": "/chirp-fetch/static-1.2410",
  "stylex-utils": "/stylex-utils/static-1.184",
  "chatspot-core": "/chatspot-core/static-1.24081",
  "copilot-toolkit": "/copilot-toolkit/static-1.12212",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13541",
  "data-fetching-client": "/data-fetching-client/static-1.10146",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5263",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9128",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29614",
  "usage-tracker": "/usage-tracker/static-1.7827",
  "cms-field-types": "/cms-field-types/static-1.5320",
  "content-icons-ui": "/content-icons-ui/static-1.2490",
  "integrations-lib": "/integrations-lib/static-1.17498",
  "customer-data-objects": "/customer-data-objects/static-1.8220",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5098",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2284",
  "graphql": "/graphql/static-1.95",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4648",
  "poll-commands": "/poll-commands/static-1.3982",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9586",
  "video-components-external": "/video-components-external/static-1.12501",
  "video-data-lib": "/video-data-lib/static-1.36159",
  "audio-components": "/audio-components/static-1.6614",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1094",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30107",
  "FileManagerImages": "/FileManagerImages/static-1.38042",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1825",
  "html-to-image": "/html-to-image/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "salesImages": "/salesImages/static-1.765",
  "ui-universal-auth": "/ui-universal-auth/static-1.9806",
  "urlinator": "/urlinator/static-1.5023",
  "video-components": "/video-components/static-1.14503",
  "video-embed": "/video-embed/static-1.36993",
  "ts-schema": "/ts-schema/static-1.4412",
  "ContentData": "/ContentData/static-1.69626",
  "layout-data-lib": "/layout-data-lib/static-1.10574",
  "react-dnd-compat": "/react-dnd-compat/static-1.5113",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2059",
  "external-options-client-types": "/external-options-client-types/static-1.4456",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6097",
  "hs-resources": "/hs-resources/static-1.695",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4169",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9385",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3567",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11654",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5934",
  "magpie-types": "/magpie-types/static-1.5394",
  "simple-logging-lib": "/simple-logging-lib/static-1.3556",
  "avatar-components": "/avatar-components/static-1.2996",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10341",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7090",
  "flux-actions": "/flux-actions/static-1.383",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5388",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14913",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6133",
  "laboratory-lib": "/laboratory-lib/static-3.7656",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8267",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10791",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1262",
  "breeze-engine-core": "/breeze-engine-core/static-1.1562",
  "highlight.js": "/highlight.js/static-1.92",
  "pulse": "/pulse/static-1.1162",
  "navigation-messaging": "/navigation-messaging/static-1.8559",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13649",
  "content-media-compositions": "/content-media-compositions/static-2.17656",
  "idb-keyval": "/idb-keyval/static-1.57",
  "media-bridge-lib": "/media-bridge-lib/static-1.19689",
  "nudge-client-utils": "/nudge-client-utils/static-1.3470",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.370",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1602",
  "social-insights-client-types": "/social-insights-client-types/static-1.22984",
  "advanced-menus-core": "/advanced-menus-core/static-1.15867",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12607",
  "ExportDialog": "/ExportDialog/static-6.10881",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35267",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4131",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4461",
  "event-emitter": "/event-emitter/static-1.1466",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.522",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4353",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3792",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4026",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6283",
  "reactive-lib": "/reactive-lib/static-1.1229",
  "trellis-migration-context": "/trellis-migration-context/static-1.87",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.847",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3523",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.665",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "nav-meta": "/nav-meta/static-1.30869",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3227",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3546",
  "onboarding-tours": "/onboarding-tours/static-1.17438",
  "whisper-core-api": "/whisper-core-api/static-1.7685",
  "fsm": "/fsm/static-1.4267",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15866",
  "simple-menus-lib": "/simple-menus-lib/static-1.17383",
  "settings-ui-lib": "/settings-ui-lib/static-1.13037",
  "persist-promise": "/persist-promise/static-1.4216",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.139",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3879",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7403",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10486",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19621",
  "growth-data-modal": "/growth-data-modal/static-1.6177",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3042",
  "navigation-components": "/navigation-components/static-1.19232",
  "nest": "/nest/static-1.743",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5653",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1505",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8172",
  "user-context": "/user-context/static-1.5564",
  "react-flip-move": "/react-flip-move/static-1.85",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7308",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2884",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3070",
  "user-context-client": "/user-context-client/static-1.5018",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18739",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15899",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8125",
  "onboarding-scopes": "/onboarding-scopes/static-1.6958"
}
};
